import { render, staticRenderFns } from "./deleteMallMenu.vue?vue&type=template&id=725e6782&scoped=true"
import script from "./deleteMallMenu.vue?vue&type=script&lang=js"
export * from "./deleteMallMenu.vue?vue&type=script&lang=js"
import style0 from "./deleteMallMenu.vue?vue&type=style&index=0&id=725e6782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725e6782",
  null
  
)

export default component.exports